import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CustomDataGrid from "../../../Components/CustomDataGrid/CustomDataGrid";
import CustomBackdrop from "../../../Components/CustomBackdrop/Barckdrop";

import axios from "axios";
import { genURL, genURLTEST } from "../../../_getjson";
import moment from "moment";
import "moment/locale/th";
import { Button, Typography, Grid } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import CustomInput from "../../../Components/CustomInput/CustomInput";
import ConditionAP from "../../../Components/ConditionSearch/Components/ConditionAP";
import ConditionAPSelect from "../../../Components/ConditionSearch/Components/ConditionSelectAP";
import {
  blackColor,
  defaultFont,
  grayColor,
} from "../../../assets/jss/psstyle/psacount";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import CustomDateRangePicker from "../../../Components/CustomDatepicker/CustomDateRangePicker";
import CustominputRang from "../../../Components/CustomInput/CustominputRang";
import CustomDepartmentInput from "../../../Components/CustomDepartment/customdepartmentinput";
import CustomSiteCodeInput from "../../../Components/CustomSiteCode/customsitecodeinput";
import CustomAPInput from "../../../Components/CustomAPInput/customapinput";
import DateConvertByMoment from "../../../CustomFunction/Date/DateconvertByMoment";
const columns = [
  { field: "id", headerName: "id", width: 40, hide: true },
  {
    field: "docdate",
    headerName: "วันที่เอกสาร",
    width: 150,
    editable: false,
  },
  {
    field: "docno",
    headerName: "เลขที่เอกสาร",
    width: 200,
    editable: false,
  },
  {
    field: "amount",
    headerName: "รวมทั้งสิ้น",
    width: 200,
    editable: false,
  },
  {
    field: "remark",
    headerName: "หมายเหตุ",
    width: 200,
    editable: false,
    flex: 1,
  },
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}
export default function Rechecked(props) {
  const [state, setState] = React.useState({
    tabValue: 0,
    rows: [],
    openbackdrop: false,
    dateStart: "",
    dateEnd: "",
    docNoStart: "",
    docNoEnd: "",
    siteCode: "",
    apCode: "",
    apMainGroup: "",
    apTableData: [],
    top: "100",
    department: "",
  });

  const loadData = async (val, ConditionData, top) => {
    setState({ ...state, openbackdrop: true });
    let url = "";
    // if (val === 'all') {
    // url = `CSPURCHASE/Search?top=100&startdate=${datestartdata != null ? datestartdata : ""}&enddate=${dateenddata != null ? dateenddata : ""}&startdocno=${docnostartdata != null ? docnostartdata : ""}&enddocno=${docnoenddata != null ? docnoenddata : ""}`
    // } else {
    url = `CSOTHEREXPENSE/SearchData?ConditionData=${ConditionData}`;
    // }
    let rs = await axios.get(genURL(url));
    //  let rs = await axios.get(genURLTEST(`/SearchData?ConditionData=${ConditionData}`), { timeout: 12000 })
    let element = [];

    if (rs.data.length > 0) {
      console.log("rs", rs.data);
      for (let index = 0; index < rs.data.length; index++) {
        await element.push({
          id: Number(index) + 1,
          docdate: moment(rs.data[index].DOCDATE).format("L"),
          docno: rs.data[index].DOCNO,
          remark: rs.data[index].REMARK,
          amount: rs.data[index].DEBTAMOUNT,
          fontcolor: rs.data[index].FONTCOLOR,
        });
        // console.log("rs elementzzzzzzzzzzz", rs.data[index].code);
      }
    }
    await setState({
      ...state,
      rows: element,
      openbackdrop: false,
    });
  };
  const resData = (e) => {
    console.log("resData resData", e);
  };
  const removeresData = (e) => {
    console.log("resData removeresData", e);
  };
  const selcetRow = async (e) => {
    await props.Dataselect(e);
    // console.log("selcetRow", e)
  };
  const resDataConditions = async (e) => {
    console.log("resDataCondition", e);
    let ConditionData = await JSON.stringify([
      {
        StartDate:
          e.dateStart === ""
            ? ""
            : e.dateStart === null
            ? ""
            : DateConvertByMoment(e.dateStart),
        EndDate:
          e.dateEnd === ""
            ? ""
            : e.dateEnd === null
            ? ""
            : DateConvertByMoment(e.dateEnd),
        StartDocNo: e.docNoStart,
        EndDocNo: e.docNoEnd,
        ApCode: e.apCode,
        SiteCode: e.siteCode,
        ApMainGroup: e.apMainGroup,
        ApTableData: JSON.stringify(e.tableData),
        Top: e.top,
      },
    ]);
    await loadData("all", ConditionData, e[3]);
  };

  const tabHandleChange = (event, newValue) => {
    setState({
      ...state,
      tabValue: newValue,
    });
  };

  const resInput = async (source, value) => {
    console.log("resInput", value);
    // if (source === "DocNo") {

    if (source === "docNo") {
      setState({
        ...state,
        docNoStart: value.docNoStart,
        docNoEnd: value.docNoEnd,
      });
    } else if (source === "docDate") {
      setState({
        ...state,
        dateStart: value.dateStart,
        dateEnd: value.dateEnd,
      });
    } else if (source === "department") {
      setState({
        ...state,
        department: value.DepartmentCode,
      });
    } else if (source === "siteCode") {
      setState({
        ...state,
        siteCode: value.siteCode,
      });
    } else if (source === "apCode") {
      console.log("apCode", value);
      setState({
        ...state,
        apCode: value,
      });
    }
  };

  const resultCondition = async (source, value) => {
    console.log("source", value);
    if (source === "apData") {
      await setState({
        ...state,
        arMainGroup: value.arMainGroup,
        arTableData: value.arTableData,
      });
    }
    //  await console.log('resultCondition', state)
  };

  const keyDown = (e) => {
    console.log("keyDown", e);
  };

  const SearchData = () => {
    console.log("SearchData", state);
    // loadData()
    resDataConditions(state);
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <Container maxWidth="xl">
        <Box sx={{ height: 500, width: "100%" }}>
          <Grid container spacing={1}>
            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
              <Button
                variant="outlined"
                startIcon={<SearchRoundedIcon />}
                sx={{
                  pt: -5,
                  height: "32px",
                  mt: 1.4,
                  borderColor: grayColor[11],
                  color: blackColor[0],
                  fontFamily: defaultFont,
                }}
                onClick={() => SearchData()}
                size="small"
              >
                ค้นหา
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomInput
                inputType={"number"}
                id={"rowSelect"}
                label={`จำนวนรายการ`}
                placeholder={
                  "ถ้าต้องการรายการทั้งหมดตามเงื่อนไขให้กรอก -1 ค่าเริ่มต้นเป็น 100"
                }
                resData={(e) =>
                  setState({
                    ...state,
                    top: e,
                  })
                }
              />
            </Grid>
          </Grid>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={state.tabValue}
              onChange={tabHandleChange}
              aria-label="basic tabs example"
            >
              <Tab label="เงื่อนไข" {...a11yProps(0)} />
              <Tab label={"เลือกเจ้าหนี้"} {...a11yProps(1)} />
            </Tabs>{" "}
            {/*    */}
            <TabPanel value={state.tabValue} index={0}>
              <Grid container spacing={3}>
                <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
                  <CustomDateRangePicker
                    label={"วันที่"}
                    resData={(e) => resInput("docDate", e)}
                    defaultValue={state}
                  />
                </Grid>
                <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
                  <CustominputRang
                    label={"เลขที่เอกสาร"}
                    resData={(e) => resInput("docNo", e)}
                    inputType={"text"}
                    keyDown={(e) => keyDown(e)}
                    defaultValue={state}
                  />
                </Grid>

                <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
                  <CustomDepartmentInput
                    label={"แผนก"}
                    resData={(e) => resInput("department", e)}
                    inputType={"text"}
                    keyDown={(e) => keyDown(e)}
                    defaultValue={state.department}
                  />
                </Grid>

                <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
                  <CustomSiteCodeInput
                    label={"สาขา"}
                    resData={(e) => resInput("siteCode", e)}
                    inputType={"text"}
                    keyDown={(e) => keyDown(e)}
                    defaultValue={state.siteCode}
                  />
                </Grid>

                <Grid2 size={{ xs: 6, sm: 12, md: 6, lg: 4, xl: 4 }}>
                  <CustomAPInput
                    label={"เจ้าหนี้"}
                    resData={(e) => resInput("apCode", e)}
                    inputType={"text"}
                    keyDown={(e) => keyDown(e)}
                    defaultValue={state.apCode}
                  />
                </Grid2>
              </Grid>
            </TabPanel>
            <TabPanel value={state.tabValue} index={1}>
              <ConditionAPSelect
                result={(e) => resultCondition("apData", e)}
                defaultValue={state}
                title={"กลุ่มเจ้าหนี้หลัก"}
              />
            </TabPanel>
          </Box>

          {state.rows.length > 0 ? (
            <CustomDataGrid
              datacolumns={columns}
              datarows={state.rows}
              rowHeight={38}
              Dataintable={(e) => resData(e)}
              Dataintableremove={(e) => removeresData(e)}
              startRow={1}
              option={[{ add: false, del: false, select: true }]}
              // checkboxSelection
              onRowClick={(e) => selcetRow([e.row])}
              // Dataselect={e => selcetRow(e)}
              RowsModelChange={(_) => console.log("RowsModelChange")}
            />
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign={"center"}>
                ไม่พบข้อมูล
              </Grid>
            </Grid>
          )}
          <CustomBackdrop open={state.openbackdrop} />
        </Box>
      </Container>
    </React.Fragment>
  );
}
